import { createContext, useContext } from 'react';
import { useProvideAuth } from './Auth';

const authContext = createContext();
// Provider component that wraps your app and makes auth object ..
// ... available to any child component that calls useAuth().

// eslint-disable-next-line react/prop-types
export function AuthProvider({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

// Hook for child Components to get the auth object ...
// ... and re-render when it changes.

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => {
  return useContext(authContext);
};
